"use client";

import { useMarketingText } from "@/lib/i18n/marketingClient";

/**
 * Marketing-only illustration of manuscript import: paste or .txt/.md upload
 * with chapter detection. Not live upload UI.
 */
export function ImportExportGlimpse() {
  const localize = useMarketingText();
  return (
    <figure
      aria-label={localize("Novilot importing a manuscript and detecting chapters from headings.")}
      className="w-full max-w-xl mx-auto lg:max-w-none"
    >
      <div className="rounded-2xl border border-border/80 bg-muted/20 p-5 shadow-sm">
        <div className="rounded-xl border border-border bg-background overflow-hidden">
          <div className="px-4 py-3 border-b border-border">
            <p className="text-sm font-semibold">{localize("Import manuscript")}</p>
            <p className="text-xs text-muted-foreground">{localize("Paste text or upload .txt / .md")}</p>
          </div>
          <div className="px-4 py-3 font-serif text-[15px] leading-relaxed text-foreground/90 bg-muted/30">
            <p className="text-xs font-sans uppercase tracking-wide text-muted-foreground mb-2">
              {localize("Detected")}
            </p>
            <ul className="space-y-1.5 font-sans text-sm">
              <li className="flex justify-between gap-3">
                <span>{localize("Chapter 1")}</span>
                <span className="text-muted-foreground">{localize("2,410 words")}</span>
              </li>
              <li className="flex justify-between gap-3">
                <span>{localize("Chapter 2")}</span>
                <span className="text-muted-foreground">{localize("3,102 words")}</span>
              </li>
              <li className="flex justify-between gap-3">
                <span>{localize("Chapter 3")}</span>
                <span className="text-muted-foreground">{localize("2,887 words")}</span>
              </li>
            </ul>
          </div>
          <div className="px-4 py-3 border-t border-border flex flex-wrap gap-2 text-xs">
            <span className="rounded-lg bg-accent text-accent-foreground px-2.5 py-1 font-medium">
              {localize("Export DOCX")}
            </span>
            <span className="rounded-lg border border-border px-2.5 py-1 text-muted-foreground">
              EPUB
            </span>
            <span className="rounded-lg border border-border px-2.5 py-1 text-muted-foreground">
              PDF
            </span>
          </div>
        </div>
      </div>
    </figure>
  );
}
